module.exports = __webpack_public_path__ + "img/ico_doc.b02938b5.png";